import { countLines } from "@/lib/text";

// Shared changelog presentation — imported by the SuperAdmin authoring page and
// the user-facing What's New page.
//
// These two kept private copies of the same map, which is how they diverged: an
// unknown category passed `undefined` as the badge class and the pill lost its
// background entirely, on both pages independently.
export const CATEGORY_TONE = {
  feature: "bg-brand-100 text-brand-700 dark:bg-brand-500/15 dark:text-brand-300",
  improvement: "bg-emerald-100 text-emerald-700 dark:bg-emerald-500/15 dark:text-emerald-300",
  fix: "bg-rose-100 text-rose-700 dark:bg-rose-500/15 dark:text-rose-300",
};

// Anything the map doesn't know still renders as a styled pill.
export const CATEGORY_FALLBACK =
  "bg-slate-100 text-slate-600 dark:bg-white/10 dark:text-slate-300";

export function categoryTone(category) {
  return CATEGORY_TONE[category] || CATEGORY_FALLBACK;
}

// The categories the API accepts (mirrors VALID_CATEGORIES in admin_platform.py).
export const CATEGORIES = [
  { value: "feature", label: "Feature" },
  { value: "improvement", label: "Improvement" },
  { value: "fix", label: "Fix" },
];

// WHO an update is shown to — mirrors VALID_AUDIENCES in admin_platform.py,
// which is itself built from core/access.ALL_ROLES. The server is authoritative;
// this list exists so the form can offer the choices and so a stored value can be
// labelled, never as a second definition of what's allowed.
//
// Audience is VISIBILITY. It does not grant or remove any permission — who may
// WRITE an update is decided by the admin guard on the API.
export const AUDIENCES = [
  { value: "all", label: "Everyone" },
  { value: "admin", label: "Company admins" },
  { value: "project_manager", label: "Project managers" },
  { value: "tester", label: "Testers" },
  { value: "developer", label: "Developers" },
  { value: "superadmin", label: "SuperAdmins" },
];

// An audience the list doesn't know (a role added server-side before this list
// caught up) still reads as itself rather than as blank.
export function audienceLabel(audience) {
  const known = AUDIENCES.find((a) => a.value === audience);
  return known ? known.label : audience || "Everyone";
}

// The most an update's description may be — mirrors MAX_CHANGELOG_BODY_LINES in
// admin_platform.py. A LINE limit, not a character one.
export const MAX_BODY_LINES = 300;

// Re-exported from lib/text so the changelog's mirror of the server's
// count_lines() and the one ExpandableText measures with are the same function.
export { countLines };

// How much of a description a feed card shows before it offers "Read more".
// Six lines is enough for a normal release note to be read in full without any
// interaction, and short enough that a 300-line one cannot turn its card into a
// page of its own.
export const BODY_PREVIEW_LINES = 6;
